import Logo from "@/components/Logo";
import { Button } from "@/components/ui/Button";
import Input from "@/components/ui/Input";
import Paragraph from "@/components/ui/Paragraph";
import { phoneSchema } from "@/schemas/auth/register";
import { yupResolver } from "@hookform/resolvers/yup";
import useGoogleAuth from "components/auth/hooks/useGoogleAuth";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

function RegisterPhone() {
  const router = useRouter();
  const { googleAuthUrl, referralLink } = useGoogleAuth();

  const { t } = useTranslation(["register", "login"]);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({ resolver: yupResolver(phoneSchema) });

  const onSubmit = data => {
    router.push(googleAuthUrl + "&phone=" + data.phone);
  };

  return (
    <>
      <Head>
        <title>{t("registerWithGoogle", { ns: "login" })}</title>
      </Head>
      <main
        className={
          "flex w-full min-h-svh relative text-foreground max-lg:p-4 blue-gradient-bg"
        }
      >
        <Image
          className="absolute inset-0 object-cover animate-opacityIncrease"
          layout="fill"
          src="/images/logo/logo-pattern.png"
          alt="logo pattern background"
        />

        <div className="flex flex-col items-center bg-background z-10 rounded-xl max-w-full h-fit mt-8 py-12 p-6 mx-auto">
          <Link href="/" passHref>
            <a className="mx-auto block mb-8">
              <Logo />
            </a>
          </Link>

          <div className="w-[500px] max-w-full lg:mx-6">
            <Paragraph className="text-2xl mx-auto w-fit block" variant="title">
              {t("registerWithGoogle", { ns: "login" })}
            </Paragraph>

            <form
              onSubmit={handleSubmit(onSubmit)}
              className="w-full grid mt-8"
            >
              <label className="block">
                <span className="block font-medium">
                  {t("phone_number", { ns: "register" })}
                </span>
                <Input
                  {...register("phone")}
                  dir="ltr"
                  type="text"
                  errorMessage={t(errors.phone?.message, { ns: "register" })}
                  className="rtl:text-end"
                  placeholder={t("phone_number", { ns: "register" })}
                  autoFocus
                />
              </label>

              <Button type="submit" className="w-full mt-4">
                {t("register_button", { ns: "register" })}
              </Button>
              <Link href={"/register?referralLink=" + referralLink} passHref>
                <Button
                  type="button"
                  variant="secondary"
                  className="w-full mt-2"
                >
                  {t("cancel_button", { ns: "register" })}
                </Button>
              </Link>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

RegisterPhone.theme = "light";

export default RegisterPhone;
